import type {Component, Editor} from 'grapesjs';

/** Preset id used when the component prop is unset and no descriptor default is given. */
export const DEFAULT_PRESET_ID_FALLBACK = 0;

export interface PresetOption {
  id: number;
  /** Border-radius preview sizes. The first value is used when the callback writes border-radius. */
  compValues: number[];
  classUnit: string;
}

export interface PresetSelectorDescriptor {
  /** Component prop name written when a preset is selected. */
  property: string;
  labelKey?: string;
  defaultPresetId?: number;
  options: readonly PresetOption[];
  /** Invoked after the preset prop is set, to apply the visual effect (e.g. border-radius). */
  onPresetSelect?: (component: Component, preset: PresetOption, editor: Editor) => void;
}
